module.exports = __webpack_public_path__ + "img/20201122_112637.f2949572.jpg";